/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

export const ai_boost_meta_ads: StateInterface["ai_boost_meta_ads"] = {
	_id: "",
	ad_id: "",
	ad_set_id: "",
	campaign_id: "",
	lead_form_id: "",
	effective_status: "",
	ad_format: "",
	primary_texts: "",
	headlines: "",
	description: "",
	call_to_action: "",
	ad_name: "",
	status: "",
	boost_id: "",
	property_id: "",
	created_at: "",
	updated_at: "",
	is_deleted: false,
	deleted_at: "",
	last_optimized_at: "",
	last_optimization_action: "",
	last_optimization_remarks: "",
	creative_description: "",
	creative_id: "",
	creative_1_1: {
		resolution: "",
		status: "",
		file_id: "",
		mime_type: ""
	},
	creative_9_16: {
		resolution: "",
		status: "",
		file_id: "",
		mime_type: ""
	}
};

export default ai_boost_meta_ads;
